export const BASE_API_URL = `billings/api/v1/`
